var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutingImageDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1E1E1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_3463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4 13.8333C16.7334 10.95 12.3917 10.9417 11.725 13.8333C11.3334 15.525 12.4084 16.9583 13.3417 17.85C14.025 18.4917 15.1 18.4917 15.7834 17.85C16.7167 16.9583 17.7834 15.525 17.4 13.8333ZM14.5917 15.1667C14.1334 15.1667 13.7584 14.7917 13.7584 14.3333C13.7584 13.875 14.125 13.5 14.5834 13.5H14.5917C15.0584 13.5 15.425 13.875 15.425 14.3333C15.425 14.7917 15.0584 15.1667 14.5917 15.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2583 23.8333C27.5917 20.95 23.2333 20.9417 22.5583 23.8333C22.1667 25.525 23.2417 26.9583 24.1833 27.85C24.8667 28.4917 25.95 28.4917 26.6333 27.85C27.575 26.9583 28.65 25.525 28.2583 23.8333ZM25.4417 25.1667C24.9833 25.1667 24.6083 24.7917 24.6083 24.3333C24.6083 23.875 24.975 23.5 25.4333 23.5H25.4417C25.9 23.5 26.275 23.875 26.275 24.3333C26.275 24.7917 25.9 25.1667 25.4417 25.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.4583H17.7666C16.8 26.4583 15.9583 25.875 15.625 24.975C15.2833 24.075 15.5333 23.0833 16.2583 22.4417L22.9166 16.6167C23.3166 16.2667 23.325 15.7917 23.2083 15.4667C23.0833 15.1417 22.7666 14.7917 22.2333 14.7917H20C19.6583 14.7917 19.375 14.5083 19.375 14.1667C19.375 13.825 19.6583 13.5417 20 13.5417H22.2333C23.2 13.5417 24.0416 14.125 24.375 15.025C24.7166 15.925 24.4666 16.9167 23.7416 17.5583L17.0833 23.3833C16.6833 23.7333 16.675 24.2083 16.7916 24.5333C16.9166 24.8583 17.2333 25.2083 17.7666 25.2083H20C20.3416 25.2083 20.625 25.4917 20.625 25.8333C20.625 26.175 20.3416 26.4583 20 26.4583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_3463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingImageDark);
export default __webpack_public_path__ + "static/media/routingImageDark.f4f08709ebec1d3eab28df09a660fb59.svg";
export { ForwardRef as ReactComponent };